<template>
    <v-dialog
        v-model="isOpen"
        max-width="350"
        @click:outside.prevent="closeDialog"
    >
        <v-card class="pa-5">
            <v-btn icon color="black" absolute top right @click="closeDialog">
                <v-icon>$close</v-icon>
            </v-btn>
            <h3 class="text-center mb-10">Job Types</h3>
            <div class="mb-5">
                <v-card
                    v-for="item in breakdownLogJobTypes"
                    :key="item.id"
                    class="pa-0 d-flex justify-space-between align-center elevation-0 mb-3"
                >
                    <v-col cols="10" class="pa-0">
                        <v-text-field
                            v-model="item.name"
                            single-line
                            solo
                            :loading="item.isUpdating"
                            v-on:change="changeHandler(item)"
                        />
                    </v-col>
                <div>
                    <v-btn fab small primary="transparent" class="elevation-0" :loading="deleting.includes(item.id)"  @click="deleteHandler(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
                </v-card>
            </div>
            <v-form ref="jobTypeForm" lazy-validation>
                <v-flex xs12 class="d-flex align-center">
                    <v-text-field
                        v-model="newName"
                        placeholder="Job Type"
                        :rules="newJobTypeRules"
                        value="true"
                        required="false"
                        autocomplete="off"
                    />
                    <v-btn color="primary" @click="addHandler" :loading="addLoading" class="ml-5">Add</v-btn>
                </v-flex>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters } from 'vuex'
    import validationRules from '@/common/validationRules'

    export default {
        name: 'BreakdownLogsJobTypesManageDialog',
        props: ['isOpen'],
        data: () => ({
            newName: '',
            newJobTypeRules: validationRules.jobTypeName,
            addLoading: false,
            deleting: []
        }),
        computed: {
            ...mapGetters(['getBreakdownLogJobTypes']),
            breakdownLogJobTypes () {
                return this.getBreakdownLogJobTypes
            }
        },
        methods: {
            closeDialog () {
                this.$emit('closeDialog')
            },
            async addHandler () {
                if (!this.$refs.jobTypeForm.validate()) return
                try {
                    this.addLoading = true
                    const result = await this.$store.dispatch('addBreakdownLogJobTypes', this.newName)
                    if (result) {
                        this.newName = ''
                        this.$refs.jobTypeForm.resetValidation()
                    }
                } catch (e) {} finally {
                    this.addLoading = false
                }
            },
            async changeHandler (item) {
                await this.$store.dispatch('updateBreakdownLogJobTypes', item)
            },
            async deleteHandler (item) {
                this.deleting.push(item.id)
                if (await this.$root.$confirmDialog.open(item.name)) {
                    await this.$store.dispatch('deleteBreakdownLogJobTypes', item.id)
                }
                this.deleting.splice(this.deleting.indexOf(item.id), 1)
            }
        }
    }
</script>
